import axiosInstance from "../lib/axiosInstance";


const Baseurl = process.env.REACT_APP_API_URL


const categoryModel = class {

    async GetList(type) {
        return await axiosInstance.get(Baseurl +`/category?type=${type}&limit=1000`);
    }
    async GetproductByCategory(id,filter) {
        return await axiosInstance.get(Baseurl +`/products?category_id=${id}${filter}`);
    }
    async GetSearch(id) {
        return await axiosInstance.get(Baseurl +`/products?search=${id}`);
    }
    async ProductDetail(id) {
        return await axiosInstance.get(Baseurl +`/products/${id}`);
    }
    async CategoryDetail(id) {
        return await axiosInstance.get(Baseurl +`/category/${id}`);
    }
}

export default new categoryModel();